module.exports = __webpack_public_path__ + "img/V21.3a778f76.jpg";